(function () {
  var widgetSelector = 'body.template_product #sm-widget-btn';
  var scheduled = false;

  function getAmount(widget) {
    var source = widget.querySelector('#dp');
    return source ? source.textContent.trim() : '';
  }

  function getTenure(widget) {
    var source = widget.querySelector('.dynamic_emis');
    return source ? source.textContent.trim() : '';
  }

  function updateWidget(widget) {
    var amount = getAmount(widget);
    var tenure = getTenure(widget);
    var copy = widget.querySelector('.mrjewels-snapmint-copy');

    if (!copy) {
      copy = document.createElement('span');
      copy.className = 'mrjewels-snapmint-copy';
      copy.innerHTML =
        '<span class="mrjewels-snapmint-summary">' +
          '<span class="mrjewels-snapmint-amount"></span>' +
          '<span class="mrjewels-snapmint-tenure"></span>' +
          ' with No Cost EMI.' +
        '</span>' +
        '<span class="mrjewels-snapmint-details">' +
          'UPI &amp; Card Accepted. ' +
          '<span class="mrjewels-snapmint-link">View EMI Options.</span>' +
        '</span>';
      widget.appendChild(copy);
    }

    var amountElement = copy.querySelector('.mrjewels-snapmint-amount');
    var formattedAmount = amount ? 'Rs. ' + amount + '/month' : 'EMI';
    if (amountElement.textContent !== formattedAmount) {
      amountElement.textContent = formattedAmount;
    }

    var tenureElement = copy.querySelector('.mrjewels-snapmint-tenure');
    var formattedTenure = tenure ? ' (' + tenure + ' months)' : '';
    if (tenureElement.textContent !== formattedTenure) {
      tenureElement.textContent = formattedTenure;
    }

    widget.classList.add('mrjewels-snapmint-widget');
    widget.setAttribute('role', 'button');
    widget.setAttribute('tabindex', '0');
    widget.setAttribute(
      'aria-label',
      amount
        ? 'Rs. ' + amount + ' per month' +
          (tenure ? ', ' + tenure + ' months, ' : ', ') +
          'with No Cost EMI. UPI and Card Accepted. View EMI Options.'
        : 'No Cost EMI available. View EMI Options.'
    );

    if (widget.dataset.mrjewelsKeyboardReady === 'true') {
      return;
    }

    widget.dataset.mrjewelsKeyboardReady = 'true';
    widget.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') {
        return;
      }

      event.preventDefault();
      widget.click();
    });
  }

  function initializeWidgets() {
    scheduled = false;
    document.querySelectorAll(widgetSelector).forEach(updateWidget);
  }

  function scheduleInitialization() {
    if (scheduled) {
      return;
    }

    scheduled = true;
    window.requestAnimationFrame(initializeWidgets);
  }

  function start() {
    scheduleInitialization();

    new MutationObserver(scheduleInitialization).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
